<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const emit = defineEmits(['confirm', 'cancel']);

const { t } = useI18n();

const isOpen = ref(false);
const value = ref('');
const pending = ref(null);

const isValidValue = () => {
  const num = Number.parseFloat(value.value);
  return value.value !== '' && !Number.isNaN(num) && num >= 0;
};

const open = context => {
  pending.value = context;
  value.value = String(context.deal?.value || '');
  isOpen.value = true;
};

const confirm = () => {
  if (!isValidValue()) return;
  emit('confirm', { ...pending.value, value: Number.parseFloat(value.value) });
  isOpen.value = false;
};

const cancel = () => {
  emit('cancel');
  isOpen.value = false;
};

defineExpose({ open });
</script>

<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    @click.self="cancel"
  >
    <div
      class="bg-n-solid-1 rounded-2xl shadow-xl w-full max-w-sm mx-4 p-6 flex flex-col gap-5"
    >
      <div class="flex flex-col gap-1">
        <h3 class="text-base font-semibold text-n-slate-12">
          {{ t('DEALS.WON_MODAL.TITLE') }}
        </h3>
        <p class="text-sm text-n-slate-10">
          {{ t('DEALS.WON_MODAL.DESCRIPTION') }}
        </p>
      </div>

      <div class="flex flex-col gap-1.5">
        <label class="text-xs font-medium text-n-slate-11">
          {{ t('DEALS.WON_MODAL.VALUE_LABEL') }}
        </label>
        <Input
          v-model="value"
          type="number"
          min="0"
          step="0.01"
          :placeholder="t('DEALS.WON_MODAL.VALUE_PLACEHOLDER')"
          custom-input-class="h-9"
          @keydown.enter="confirm"
        />
      </div>

      <div class="flex gap-2 justify-end">
        <Button
          :label="t('DEALS.WON_MODAL.CANCEL')"
          variant="ghost"
          color="slate"
          @click="cancel"
        />
        <Button
          :label="t('DEALS.WON_MODAL.CONFIRM')"
          color="teal"
          :disabled="!isValidValue()"
          @click="confirm"
        />
      </div>
    </div>
  </div>
</template>
